export default "__VITE_ASSET__kFBMjuFf__"